<script setup>
import { useLoadingStore } from "./stores/loadingStore";
import { useMessageStore } from "./stores/messageStore";
import isColorBright from "./util/isColorBright";
import { useTheme } from "vuetify";

const loadingStore = useLoadingStore();
const messageStore = useMessageStore();
const theme = useTheme();

const isPrimaryColorBright = computed(() => {
  return isColorBright(theme.current.value.colors.primary);
});

const isSecondaryColorBright = computed(() => {
  return isColorBright(theme.current.value.colors.secondary);
});

const isAccentColorBright = computed(() => {
  return isColorBright(theme.current.value.colors.accent);
});
</script>

<template>
  <v-app
    :class="{
      'primary-color-is-bright': isPrimaryColorBright,
      'secondary-color-is-bright': isSecondaryColorBright,
      'accent-color-is-bright': isAccentColorBright,
    }"
  >
    <v-snackbar
      v-for="(message, index) in messageStore.messages"
      :key="index"
      :color="message.type || 'info'"
      :model-value="!!message.message"
      :timeout="message.timeout || 7000"
      class="mt-5"
    >
      {{ message.key ? $t(message.key, message.params) : message.message }}
      <v-icon color="white" v-if="message.reactionAddons">{{ message.reactionAddons.type }}</v-icon>
      <template #actions>
        <v-btn icon="mdi-close" @click="messageStore.messages.splice(index, 1)" color="white" />
      </template>
    </v-snackbar>
    <v-overlay :model-value="loadingStore.loading" opacity="0.7" z-index="2000" class="justify-center align-center" persistent>
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <router-view />
  </v-app>
</template>
